export default __webpack_public_path__ + "static/media/vector-creator.59219f20.png";